var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "top" }, [
      _c("img", {
        attrs: { id: "logo", src: _vm.staticUrl + "logo/T9LOGO.png" },
        on: { click: _vm.initDoc }
      })
    ]),
    _vm._v(" "),
    _vm.isDevEnv
      ? _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "bgBox" }),
          _vm._v(" "),
          _c("div", { staticClass: "gameList" }, [
            _c("div", { staticClass: "rowSize" }, [
              _c("div", { staticClass: "gameBoxLi" }, [
                _c("div", {
                  staticClass: "gameBox eventbox",
                  style: {
                    "background-image":
                      "url(" + _vm.staticUrl + "icon/" + "3004" + ".png)"
                  },
                  on: {
                    click: function($event) {
                      return _vm.playMock(3004)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "gameNameBox" }, [
                  _vm._v("3004紀錄模擬器")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gameBoxLi" }, [
                _c("div", {
                  staticClass: "gameBox eventbox",
                  style: {
                    "background-image":
                      "url(" + _vm.staticUrl + "icon/" + "4009" + ".png)"
                  },
                  on: {
                    click: function($event) {
                      return _vm.playMock(4009)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "gameNameBox" }, [
                  _vm._v("4009紀錄模擬器")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gameBoxLi" }, [
                _c("div", {
                  staticClass: "gameBox eventbox",
                  style: {
                    "background-image":
                      "url(" + _vm.staticUrl + "icon/" + "3007" + ".png)"
                  },
                  on: {
                    click: function($event) {
                      return _vm.playMock(3007)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "gameNameBox" }, [
                  _vm._v("3007紀錄模擬器")
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("span", { staticClass: "versionTxt" }, [_vm._v("Version ⚅ 1.2.1")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ac022cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ac022cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameMock.vue
// module id = null
// module chunks = 